import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-initialsing',
  imports: [],
  templateUrl: './survey-initialsing.html',
  styleUrl: './survey-initialsing.css',
})
export class SurveyInitialsing {

}
